module.exports = __webpack_public_path__ + "static/Socotec-58b7c355dabb06df9cfa9dbb96c0b3a3.png";